import { Component } from '@angular/core';
import { LayoutConfig } from 'src/app/components/app-layout/app-layout.component';

@Component({
  selector: 'app-public-layout',
  standalone: false,
  templateUrl: './public-layout.component.html'
})
export class PublicLayoutComponent {
  layoutConfig: LayoutConfig = {
    showSidebar: false,
    showHeader: true,
    showNotificationsIcon: false,
    showUserProfileButton: false,
    footerText: "© WIPO " + new Date().getFullYear()
  };
}
